import React from "react";
import styled from "styled-components";

const ErrorContainer = styled.div`
    min-width: 170px;
    margin: 50px;
`;

const NoDataError = () => (<ErrorContainer>No Data</ErrorContainer>);

export default NoDataError;